<template>
  <div>
    <v-card-title class="mt-5"> </v-card-title>
    <v-data-table
      :headers="headers"
      :items="items"
      hide-default-footer
      disable-pagination
      :search="search"
      dense
      height="65vh"
      fixed-header
    >
      <template v-slot:top>
        <v-row class="pb-1">
          <v-col cols="auto">
            <span class="text-h6 basic--text">EXPORT HISTORY</span>
          </v-col>
          <v-divider class="" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-col cols="5">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              outlined
              dense
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col cols="auto">
            <v-btn color="accent" @click="getExportHistory"
              ><v-icon> mdi-refresh </v-icon> Refresh</v-btn
            >
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.date`]="{ item }">
        <tr>
          <td>
            {{ item.date.split("T")[0] }}
            {{ item.date.split("T")[1].split(".")[0] }}
          </td>
        </tr>
      </template>
      <template v-slot:[`item.file`]="{ item }">
        <tr>
          <td>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="success"
                  @click="downloadFile(item)"
                  v-bind="attrs"
                  v-on="on"
                  >mdi-download</v-icon
                >
              </template>
              <span>Download file</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "ExportHistory",
  props: {},
  components: {},
  data: () => ({
    headers: [
      {
        text: "File",
        align: "start",
        value: "file",
        divider: true,
        class: "footer basic--text",
      },
      {
        text: "Date",
        align: "start",
        value: "date",
        divider: true,
        class: "footer basic--text",
      },
      {
        text: "Name",
        align: "start",
        value: "firstName",
        divider: true,
        class: "footer basic--text",
      },
      {
        text: "Surname",
        align: "start",
        value: "lastName",
        divider: true,
        class: "footer basic--text",
      },
    ],
    items: [],
    search: "",
  }),
  computed: {},
  methods: {
    async getExportHistory() {
      try {
        const response = await this.$store.dispatch("getExportHistory");
        this.items = response.data;
        // this.items.sort(function (a, b) {
        //   return new Date(b.date) - new Date(a.date);
        // });
      } catch (error) {
        console.log(error);
      }
    },
    downloadFile(data) {
      let name = this.transformName(data.firstName);
      let surname = this.transformName(data.lastName);
      let filename = `${name}_${surname}_${data.date._nanoseconds}.csv`;
      const url = window.URL.createObjectURL(new Blob([data.file]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    },
    transformName(string) {
      let returnString = string.toLowerCase();
      //Convert Characters
      returnString = returnString.replace(/ą/g, "a");
      returnString = returnString.replace(/č/g, "c");
      returnString = returnString.replace(/ę/g, "e");
      returnString = returnString.replace(/ė/g, "e");
      returnString = returnString.replace(/į/g, "i");
      returnString = returnString.replace(/š/g, "s");
      returnString = returnString.replace(/ų/g, "u");
      returnString = returnString.replace(/ū/g, "u");
      returnString = returnString.replace(/ž/g, "z");

      return returnString;
    },
  },
  async mounted() {
    await this.getExportHistory();
  },
};
</script>